import { SeeMoreLongText } from "../../../common/components/SeeMoreLongText";
import { Trans, useTranslation } from "react-i18next";
import { PRIVACY_PAGE } from "../../../utils/url/staticUrls";
import { CheckboxWithLabel, type CheckboxWithLabelProps } from "../../../common/components/CheckboxWithLabel";

export const MarketingConsentCheckbox = (props: CheckboxWithLabelProps) => {
  const { i18n } = useTranslation();
  return (
    <CheckboxWithLabel {...props}>
      <SeeMoreLongText
        disabled={props.disabled}
        shortText={<Trans i18nKey={"registration.marketing.trackingConsent.short"} i18n={i18n} />}
        fullText={
          <Trans
            i18nKey={"registration.marketing.trackingConsent.full"}
            i18n={i18n}
            components={{
              unsubscribeEmail: <a href={"mailto: unsubscribe@schaeffler.com"} />,
              privacyLink: <a href={PRIVACY_PAGE} target={"_blank"} />,
            }}
          />
        }
      />
    </CheckboxWithLabel>
  );
};
